export const sections = [
  {
    title: 'Work Experience',
    items: [
      {
        subItem_title: 'Junior Developer • July 2021 - Present',
        subtitle: 'D2 Creative • Full Time',
        description: 'Currently developing web applications for different clients and industry sectors while utilizing a variety of frameworks and programming languages including: JavaScript, PHP, TypeScript, React, and Next.js.'
      }, 
      {
        subItem_title: 'Frontend Developer • March - July 2021',
        subtitle: 'Impakter • Internship',
        description: 'Design and develop the Frontend of the Certificates Tool application while utilizing reusable code with Vue.js and Bootstrap. to complete projects in the future. Designed UI wireframes using Figma. Developed Frontend with Vue.js and Bootstrap.',
        listItems: [
          'Designed UI wireframes using Figma',
          'Created UI of the certificate tool to detect environmental or social impact for companies',
          'Transformed business and functional needs into documented technical specifications in collaboration with team members'
        ]
      }
    ]
  },
  {
    title: 'Education',
    items: [
      {
        subItem_title: 'BACHELOR’S OF APPLIED SCIENCE DEGREE • 2019 - 2021',
        subtitle: 'Computing and Software Development • GPA: 3.71',
        description: 'Lake Washington Institute of Technology • Seattle, WA'
      },
      {
        subItem_title: 'ASSOCIATE’S OF APPLIED SCIENCE • 2017 - 2019',
        subtitle: 'Computing and Software Development • GPA: 3.68',
        description: 'Lake Washington Institute of Technology • Seattle, WA'
      },
      {
        subItem_title: 'BACHELOR’S DEGREE • 2007 - 2011',
        subtitle: 'Graphic Design • GPA: 3.80',
        description: 'Universidad de Guadalajara - CUAAD • Guadalajara, MX'
      }    
    ]
  }
]